import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lover.mp3'


const _hoisted_1 = {
  ref: "bgMusic",
  loop: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("source", {
        src: _imports_0,
        type: "audio/mpeg"
      }, null, -1)
    ]))], 512),
    _createVNode(_component_router_view)
  ], 64))
}